// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostAProject-page-fjQEo {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --green: #16a34a;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.PostAProject-wrap-blo7j {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 24px;
}

/* HERO */

.PostAProject-hero-Nm5Yo {
  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),
    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;
  padding: 48px 0 28px;
  text-align: center;
}

.PostAProject-eyebrow-qb5c8 {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 12px;
}

.PostAProject-h1-tu209 {
  font-size: clamp(28px, 4.6vw, 44px);
  line-height: 1.07;
  font-weight: 800;
  margin: 0 auto 12px;
  max-width: 680px;
}

.PostAProject-hl-UKLJU { color: var(--red); }

.PostAProject-sub-rgHO8 {
  font-size: clamp(15px, 2.2vw, 18px);
  color: var(--muted);
  max-width: 580px;
  margin: 0 auto;
  line-height: 1.55;
}

.PostAProject-eyebrowSm-AoMaS {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 10px;
}

.PostAProject-ctaRow-D1rN8 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-top: 8px;
}

.PostAProject-ctaRow-D1rN8 .PostAProject-btn-elFoH { padding: 13px 26px; }

/* TRUST SIGNALS */

.PostAProject-trustRow-wJPBd {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px 22px;
  margin-top: 24px;
}

.PostAProject-trustItem-OHHuy {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--ink);
}

.PostAProject-trustItem-OHHuy svg {
  width: 18px;
  height: 18px;
  color: var(--green);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

/* VALUE PROPS */

.PostAProject-valueWrap-OzbpT {
  padding: 12px 0 56px;
  background: #fff;
}

.PostAProject-valueGrid-v1BNx {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.PostAProject-valueCard-QckER {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 24px;
  background: #fff;
  -webkit-box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);
          box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);
}

.PostAProject-valueIc-taZHb {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 16px;
}

.PostAProject-valueIc-taZHb svg { width: 28px; height: 28px; }

.PostAProject-valueTitle-sUyls { margin: 0 0 8px; font-size: 18px; font-weight: 800; }

.PostAProject-valueBody-kmPF0 { margin: 0; font-size: 14.5px; color: var(--muted); line-height: 1.55; }

/* HOW IT WORKS */

.PostAProject-howWrap-DbE5F {
  padding: 8px 0 72px;
  background: #fff;
}

.PostAProject-howTitle-lNMSz {
  font-size: clamp(22px, 3vw, 30px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 28px;
}

.PostAProject-howGrid-OvQ1V {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.PostAProject-howCard-g8DuO {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 26px 24px;
  background: var(--bg);
}

.PostAProject-howNo-AFb_s {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font-weight: 800;
  font-size: 16px;
  margin-bottom: 14px;
}

.PostAProject-howCardTitle-iwvEK { margin: 0 0 8px; font-size: 17px; font-weight: 800; }

.PostAProject-howCardBody-P3KHq { margin: 0; font-size: 14px; color: var(--muted); line-height: 1.55; }

.PostAProject-howCta-R6baj {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-top: 32px;
}

.PostAProject-btnText-g4OAb {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  color: var(--muted);
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: underline;
  padding: 8px;
}

.PostAProject-btnText-g4OAb:hover { color: var(--red); }

/* BODY */

.PostAProject-body-EjlZ_ { padding: 8px 0 80px; background: #fff; }

.PostAProject-loading-R3FG0,
.PostAProject-centerState-IQCb2 {
  padding: 72px 0;
  text-align: center;
  color: var(--muted);
  font-weight: 600;
}

/* STEP PROGRESS */

.PostAProject-steps-M0psp {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 6px;
  margin: 0 0 26px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.PostAProject-stepNode-um_Yx {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 9px;
  color: var(--muted);
  font-weight: 700;
  font-size: 13.5px;
  white-space: nowrap;
}

.PostAProject-stepDot-XpuCq {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border: 2px solid var(--line);
  font-size: 12px;
  font-weight: 800;
  background: #fff;
  color: var(--muted);
}

.PostAProject-stepDone-fHDz_ .PostAProject-stepDot-XpuCq { background: var(--green); border-color: var(--green); color: #fff; }

.PostAProject-stepActive-r9cqs .PostAProject-stepDot-XpuCq { background: var(--red); border-color: var(--red); color: #fff; }

.PostAProject-stepActive-r9cqs { color: var(--ink); }

.PostAProject-stepBar-ERqhF { width: 26px; height: 2px; background: var(--line); border-radius: 2px; -webkit-transition: background 0.2s; transition: background 0.2s; }

.PostAProject-stepBarDone-WF6er { background: var(--green); }

/* CARD */

.PostAProject-card-axpSj {
  border: 1px solid var(--line);
  border-radius: 18px;
  background: #fff;
  -webkit-box-shadow: 0 1px 2px rgba(15, 18, 20, 0.04);
          box-shadow: 0 1px 2px rgba(15, 18, 20, 0.04);
  padding: 26px;
}

.PostAProject-cardTitle-HAkU2 { font-size: 22px; font-weight: 800; margin: 0 0 4px; }

.PostAProject-cardSub-vJYrD { color: var(--muted); font-size: 14.5px; margin: 0 0 20px; line-height: 1.5; }

/* SECTION/CATEGORY GRID */

.PostAProject-grid-gIlXC {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.PostAProject-tile-Nvcd7 {
  text-align: left;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fff;
  padding: 16px 16px 14px;
  cursor: pointer;
  -webkit-transition: border-color 0.15s, -webkit-box-shadow 0.15s, -webkit-transform 0.05s;
  transition: border-color 0.15s, -webkit-box-shadow 0.15s, -webkit-transform 0.05s;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s, -webkit-box-shadow 0.15s, -webkit-transform 0.05s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 13px;
}

.PostAProject-tile-Nvcd7:hover { border-color: var(--red); -webkit-box-shadow: 0 6px 18px rgba(232, 35, 43, 0.08); box-shadow: 0 6px 18px rgba(232, 35, 43, 0.08); }

.PostAProject-tile-Nvcd7:active { -webkit-transform: translateY(1px); -ms-transform: translateY(1px); transform: translateY(1px); }

/* LP-NATIVE selected category tile */

.PostAProject-tileOn-B9u0B { border-color: var(--red); -webkit-box-shadow: 0 6px 18px rgba(232, 35, 43, 0.12); box-shadow: 0 6px 18px rgba(232, 35, 43, 0.12); background: #fff7f6; }

.PostAProject-tileOn-B9u0B .PostAProject-tileIcon-U4zlx { background: var(--red); color: #fff; }

.PostAProject-tileIcon-U4zlx {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.PostAProject-tileIcon-U4zlx svg { width: 22px; height: 22px; }

.PostAProject-tileImg-jltAm { width: 42px; height: 42px; border-radius: 11px; -o-object-fit: cover; object-fit: cover; -webkit-box-flex: 0; -ms-flex: 0 0 auto; flex: 0 0 auto; }

.PostAProject-tileBody-nE5T5 { min-width: 0; }

.PostAProject-tileName-H2AqL { font-weight: 700; font-size: 15px; }

.PostAProject-tileMeta-WWHwa { color: var(--muted); font-size: 12.5px; margin-top: 2px; }

/* BREADCRUMB */

.PostAProject-crumb-Mmzdh {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  font-size: 13px;
  color: var(--muted);
  margin: 0 0 18px;
}

.PostAProject-crumbBtn-LeSv6 {
  border: none;
  background: none;
  color: var(--red);
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
}

.PostAProject-crumbSep-omyIs { opacity: 0.5; }

.PostAProject-crumbCur-wy5cJ { color: var(--ink); font-weight: 700; }

/* QUESTION BLOCK */

.PostAProject-q-pKAyR { margin: 0 0 24px; }

.PostAProject-qLabel-oe0rg { font-weight: 700; font-size: 15.5px; margin: 0 0 4px; }

.PostAProject-qReq-qraBK { color: var(--red); margin-left: 4px; }

.PostAProject-qHelp-lAOxJ { color: var(--muted); font-size: 13px; margin: 0 0 12px; line-height: 1.45; }

/* CHIPS */

.PostAProject-chips-bWULB { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 8px; }

.PostAProject-chip-XfkoF {
  border: 1px solid var(--line);
  background: #fff;
  border-radius: 999px;
  padding: 9px 16px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  cursor: pointer;
  -webkit-transition: border-color 0.12s, background 0.12s, color 0.12s;
  transition: border-color 0.12s, background 0.12s, color 0.12s;
}

.PostAProject-chip-XfkoF:hover { border-color: var(--red); }

.PostAProject-chipOn-ovbij { background: var(--red); border-color: var(--red); color: #fff; }

.PostAProject-moreBtn-dukTo {
  border: 1px dashed var(--line);
  background: #fff;
  border-radius: 999px;
  padding: 9px 16px;
  font-size: 14px;
  font-weight: 700;
  color: var(--muted);
  cursor: pointer;
}

.PostAProject-moreBtn-dukTo:hover { border-color: var(--red); color: var(--red); }

/* INPUTS */

.PostAProject-input-THEDe,
.PostAProject-textarea-eLBIC,
.PostAProject-select-I3wOG {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 15px;
  font-family: inherit;
  color: var(--ink);
  background: #fff;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  outline: none;
  -webkit-transition: border-color 0.12s, -webkit-box-shadow 0.12s;
  transition: border-color 0.12s, -webkit-box-shadow 0.12s;
  transition: border-color 0.12s, box-shadow 0.12s;
  transition: border-color 0.12s, box-shadow 0.12s, -webkit-box-shadow 0.12s;
}

.PostAProject-input-THEDe:focus,
.PostAProject-textarea-eLBIC:focus,
.PostAProject-select-I3wOG:focus {
  border-color: var(--red);
  -webkit-box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.1);
          box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.1);
}

.PostAProject-textarea-eLBIC { min-height: 120px; resize: vertical; line-height: 1.5; }

.PostAProject-zip-AWTvv { max-width: 200px; }

.PostAProject-twoCol-EHzhI { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

.PostAProject-fieldLabel-yHK7D { font-weight: 700; font-size: 14px; margin: 0 0 6px; }

/* Google Places address autocomplete dropdown (street-address field) */

.PostAProject-addrField-hd2Ej { position: relative; }

.PostAProject-addrDropdown-o42TZ {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 30;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 14px;
  -webkit-box-shadow: 0 14px 40px rgba(15, 18, 20, 0.12);
          box-shadow: 0 14px 40px rgba(15, 18, 20, 0.12);
  max-height: 260px;
  overflow-y: auto;
}

.PostAProject-addrOption-Yfn3W {
  padding: 10px 12px;
  font-size: 14px;
  color: var(--ink);
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.1s, color 0.1s;
  transition: background 0.1s, color 0.1s;
}

.PostAProject-addrOption-Yfn3W:hover { background: #fff1f0; color: var(--red-d); }

/* PHOTO UPLOAD */

.PostAProject-upload-xuvRw {
  border: 1.5px dashed var(--line);
  border-radius: 14px;
  padding: 22px;
  text-align: center;
  cursor: pointer;
  color: var(--muted);
  -webkit-transition: border-color 0.12s, background 0.12s;
  transition: border-color 0.12s, background 0.12s;
}

.PostAProject-upload-xuvRw:hover { border-color: var(--red); background: #fffafa; }

.PostAProject-uploadIcon-V9giM { color: var(--red); margin-bottom: 8px; }

.PostAProject-uploadIcon-V9giM svg { width: 26px; height: 26px; }

.PostAProject-uploadHint-Efszq { font-size: 13px; }

.PostAProject-thumbRow-gEDdc { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 10px; margin-top: 12px; }

.PostAProject-thumb-TJjrx {
  position: relative;
  width: 84px;
  height: 84px;
  border-radius: 11px;
  overflow: hidden;
  border: 1px solid var(--line);
}

.PostAProject-thumb-TJjrx img { width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; }

.PostAProject-thumbX-adp0P {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: none;
  background: rgba(15, 18, 20, 0.7);
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}

/* REVIEW */

.PostAProject-reviewBlock-ZuDBx { border: 1px solid var(--line); border-radius: 14px; padding: 16px 18px; margin-bottom: 12px; }

.PostAProject-reviewHead-Kt6Cz { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; -webkit-box-align: center; -ms-flex-align: center; align-items: center; margin-bottom: 8px; }

.PostAProject-reviewHead-Kt6Cz h4 { margin: 0; font-size: 15px; font-weight: 800; }

.PostAProject-reviewRow-w_wOo { display: -webkit-box; display: -ms-flexbox; display: flex; gap: 10px; font-size: 14px; padding: 4px 0; }

.PostAProject-reviewKey-hNnVZ { color: var(--muted); min-width: 160px; }

.PostAProject-reviewVal-Y0B4t { color: var(--ink); font-weight: 600; }

/* FOOTER NAV */

.PostAProject-footer-IyHBN {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--line);
}

.PostAProject-btn-elFoH {
  border-radius: 12px;
  padding: 12px 22px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  border: 1px solid var(--line);
  background: #fff;
  color: var(--ink);
}

.PostAProject-btnGhost-_AP8Z:hover { border-color: var(--ink); }

.PostAProject-btnPrimary-cJGAY {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}

.PostAProject-btnPrimary-cJGAY:hover { background: var(--red-d); border-color: var(--red-d); }

.PostAProject-btn-elFoH:disabled { opacity: 0.5; cursor: not-allowed; }

/* MESSAGES */

.PostAProject-errorBox-oMo0r {
  background: #fff0ef;
  border: 1px solid #f5c6c4;
  color: var(--red-d);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 18px;
}

.PostAProject-fieldErr-JXsxI { color: var(--red); font-size: 12.5px; font-weight: 600; margin-top: 6px; }

/* SUCCESS */

.PostAProject-success-ob87T { text-align: center; padding: 18px 0 6px; }

.PostAProject-successIcon-A3ZD_ {
  width: 68px;
  height: 68px;
  border-radius: 999px;
  background: #eafaf0;
  color: var(--green);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 0 auto 18px;
}

.PostAProject-successIcon-A3ZD_ svg { width: 34px; height: 34px; }

.PostAProject-successTitle-a0Iby { font-size: 24px; font-weight: 800; margin: 0 0 8px; }

.PostAProject-successText-ISeUv { color: var(--muted); font-size: 15px; max-width: 460px; margin: 0 auto 22px; line-height: 1.55; }

/* INLINE AUTH (shown at submit for logged-out clients) */

.PostAProject-authPanel-rAqXS { padding: 4px 0 2px; }

.PostAProject-authTitle-afeiy { font-size: 22px; font-weight: 800; margin: 0 0 8px; }

.PostAProject-authHint-Fu2vu { color: var(--muted); font-size: 14.5px; line-height: 1.55; margin: 0 0 18px; max-width: 540px; }

.PostAProject-noticeBox-Bme94 {
  background: #eafaf0;
  border: 1px solid #bfe6cd;
  color: #1b7a45;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 18px;
}

/* COMPLETENESS BAR */

.PostAProject-completeBox-Dz_1b {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 16px 18px;
  margin: 0 0 22px;
  background: var(--bg);
}

.PostAProject-completeTop-m8aMZ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 10px;
}

.PostAProject-completeLabel-s8gWT { font-weight: 800; font-size: 14px; }

.PostAProject-completeScore-gc5Na {
  font-weight: 800;
  font-size: 14px;
  color: var(--red);
}

.PostAProject-completeScoreOk-da1lR { color: var(--green); }

.PostAProject-completeTrack-EFSKJ {
  position: relative;
  height: 10px;
  border-radius: 999px;
  background: #eceef0;
  overflow: visible;
}

.PostAProject-completeFill-Ws0By {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 999px;
  background: var(--red);
  -webkit-transition: width 0.25s ease;
  transition: width 0.25s ease;
}

.PostAProject-completeFillOk-GjrYV { background: var(--green); }

.PostAProject-completeGate-bWKUB {
  position: absolute;
  top: -3px;
  width: 2px;
  height: 16px;
  background: #0f1214;
  opacity: 0.45;
}

.PostAProject-completeHint-v_oKu { font-size: 13px; color: var(--muted); margin: 10px 0 0; line-height: 1.45; }

.PostAProject-completeList-BFWr6 { list-style: none; margin: 10px 0 0; padding: 0; }

.PostAProject-completeItem-t2c5B {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--ink);
  font-weight: 600;
  padding: 3px 0;
}

.PostAProject-completeDot-iWRGm {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--red);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

/* GUIDED PHOTO SLOTS */

.PostAProject-photoSummary-RA1k7 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 14px;
  margin: 0 0 16px;
}

.PostAProject-photoCount-HyqXZ {
  font-weight: 800;
  font-size: 14px;
  color: var(--ink);
  background: #fff0ef;
  border-radius: 999px;
  padding: 6px 14px;
}

.PostAProject-photoReq-aMxTA { font-weight: 700; font-size: 13px; color: var(--muted); }

.PostAProject-slotGrid-WCMoo {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.PostAProject-slotTile-lHUol {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 14px;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
}

.PostAProject-slotTileDone-XLcCX { border-color: var(--green); background: #f6fdf9; }

.PostAProject-slotHead-X3Vls { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; gap: 8px; }

.PostAProject-slotLabel-Hly9i { font-weight: 700; font-size: 13.5px; line-height: 1.35; }

.PostAProject-slotReq-C2n7K {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  font-size: 11px;
  font-weight: 800;
  color: var(--red);
  background: #fff0ef;
  border-radius: 999px;
  padding: 3px 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.PostAProject-slotOpt-YxFDX {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  font-size: 11px;
  font-weight: 700;
  color: var(--muted);
  background: var(--bg);
  border-radius: 999px;
  padding: 3px 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.PostAProject-slotDrop-cScz4 {
  border: 1.5px dashed var(--line);
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  cursor: pointer;
  color: var(--muted);
  -webkit-transition: border-color 0.12s, background 0.12s;
  transition: border-color 0.12s, background 0.12s;
}

.PostAProject-slotDrop-cScz4:hover { border-color: var(--red); background: #fffafa; }

.PostAProject-slotPreview-xSAjK {
  position: relative;
  width: 100%;
  height: 130px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--line);
}

.PostAProject-slotPreview-xSAjK img { width: 100%; height: 100%; -o-object-fit: cover; object-fit: cover; }

.PostAProject-slotPdf-HwNi4 { padding: 14px; font-size: 12px; color: var(--muted); }

.PostAProject-slotDoneBadge-Vzlun {
  position: absolute;
  bottom: 6px;
  left: 6px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: var(--green);
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.PostAProject-slotDoneBadge-Vzlun svg { width: 14px; height: 14px; }

/* MEASUREMENTS */

.PostAProject-measureGrid-J8lbd {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 18px;
}

.PostAProject-measureField-tALzP { min-width: 0; }

@media (max-width: 900px) {
  .PostAProject-valueGrid-v1BNx { grid-template-columns: 1fr; }
  .PostAProject-howGrid-OvQ1V { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 640px) {
  .PostAProject-twoCol-EHzhI { grid-template-columns: 1fr; }
  .PostAProject-howGrid-OvQ1V { grid-template-columns: 1fr; }
  .PostAProject-stepNode-um_Yx span:last-child { display: none; }
}

/* ---- Photo handoff (scan-to-add-photos-from-your-phone) ---- */

.PostAProject-handoffPanel-Phd1N {
  margin-top: 20px;
}

.PostAProject-handoffOpenBtn-jpYVP {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 10px;
  border: 1.5px dashed var(--red);
  background: rgba(232, 35, 43, 0.04);
  color: var(--red-d);
  border-radius: 14px;
  padding: 16px 18px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  -webkit-transition: background 0.15s ease, border-color 0.15s ease;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.PostAProject-handoffOpenBtn-jpYVP:hover {
  background: rgba(232, 35, 43, 0.08);
}

.PostAProject-handoffPhone-k5aZe { font-size: 18px; }

.PostAProject-handoffOpen-UXJ8G {
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  -webkit-box-shadow: 0 8px 28px rgba(15, 18, 20, 0.06);
          box-shadow: 0 8px 28px rgba(15, 18, 20, 0.06);
  overflow: hidden;
}

.PostAProject-handoffHead-uLE66 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid var(--line);
  background: var(--bg);
}

.PostAProject-handoffTitle-MKgog {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: -0.2px;
}

.PostAProject-handoffClose-FPuJw {
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: var(--muted);
  cursor: pointer;
  padding: 0 4px;
}

.PostAProject-handoffBody-xpXyf { padding: 20px 18px; }

.PostAProject-handoffGrid-UYwmo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 20px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.PostAProject-handoffQr-QZolq {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 160px;
  height: 160px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 8px;
}

.PostAProject-handoffQr-QZolq svg { width: 100%; height: 100%; display: block; }

.PostAProject-handoffNoQr-qX_n2 { font-size: 13px; color: var(--muted); text-align: center; }

.PostAProject-handoffText-w5uE5 { -webkit-box-flex: 1; -ms-flex: 1 1 auto; flex: 1 1 auto; min-width: 0; }

.PostAProject-handoffLead-vKSlN {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
}

.PostAProject-handoffSmall-zww5O {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--muted);
  line-height: 1.5;
}

.PostAProject-handoffLink-_wIU8 {
  display: inline-block;
  font-size: 12px;
  color: var(--red-d);
  word-break: break-all;
  text-decoration: none;
}

.PostAProject-handoffLink-_wIU8:hover { text-decoration: underline; }

.PostAProject-handoffCount-Meam4 {
  margin-top: 14px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: var(--green);
}

.PostAProject-handoffCheck-dmeHG {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--green);
  color: #fff;
  font-size: 12px;
}

.PostAProject-handoffRetry-dJgDR {
  border: 1px solid var(--line);
  background: #fff;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

@media (max-width: 640px) {
  .PostAProject-handoffGrid-UYwmo { -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; text-align: center; }
  .PostAProject-handoffQr-QZolq { width: 200px; height: 200px; }
}

/* AI "describe your project in your own words" assistant (start of wizard) */

.PostAProject-aiBox-DxX0a {
  border: 1px solid #f6d4d3;
  background: -webkit-gradient(linear, left top, left bottom, from(#fff7f6), to(#ffffff));
  background: linear-gradient(180deg, #fff7f6, #ffffff);
  border-radius: 16px;
  padding: 18px;
  margin: 0 0 22px;
  -webkit-box-shadow: 0 1px 2px rgba(15, 18, 20, 0.03);
          box-shadow: 0 1px 2px rgba(15, 18, 20, 0.03);
}

.PostAProject-aiHead-i9e4G {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.PostAProject-aiBadge-0rMHD {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--red);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.PostAProject-aiTitle-FKrL6 { font-size: 16px; font-weight: 800; color: var(--ink); }

.PostAProject-aiSub-YDhoo { font-size: 13.5px; color: var(--muted); margin-top: 2px; line-height: 1.45; }

.PostAProject-aiTextarea-z13x2 {
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14.5px;
  line-height: 1.5;
  font-family: inherit;
  color: var(--ink);
  background: #fff;
  resize: vertical;
  min-height: 96px;
}

.PostAProject-aiTextarea-z13x2:focus { outline: none; border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }

.PostAProject-aiDone-HTmID {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
  font-size: 13.5px;
  line-height: 1.45;
}

.PostAProject-aiDone-HTmID svg { -webkit-box-flex: 0; -ms-flex: none; flex: none; width: 18px; height: 18px; color: var(--green); margin-top: 1px; }

.PostAProject-aiFollow-BCUMj {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff7f6;
  border: 1px solid #f6d4d3;
  color: var(--ink);
  font-size: 13.5px;
  line-height: 1.45;
}

.PostAProject-aiErr-yu5xo {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fafbfc;
  border: 1px solid var(--line);
  color: var(--muted);
  font-size: 13.5px;
  line-height: 1.45;
}

.PostAProject-aiActions-nLlho {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 14px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-top: 14px;
}

.PostAProject-aiBtn-Ckgd9 { display: -webkit-inline-box; display: -ms-inline-flexbox; display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 8px; }

.PostAProject-aiHint-PtSc8 { font-size: 12.5px; color: var(--muted); }

.PostAProject-aiSpinner-uCBNy {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-top-color: #fff;
  border-radius: 50%;
  -webkit-animation: PostAProject-aiSpin-EGlwU 0.7s linear infinite;
          animation: PostAProject-aiSpin-EGlwU 0.7s linear infinite;
}

@-webkit-keyframes PostAProject-aiSpin-EGlwU { to { -webkit-transform: rotate(360deg); transform: rotate(360deg); } }

@keyframes PostAProject-aiSpin-EGlwU { to { -webkit-transform: rotate(360deg); transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./src/routes/post-a-project/PostAProject.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;;AACT;EACE;qEACmE;EACnE,oBAAoB;EACpB,kBAAkB;AACpB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,yBAAM,iBAAiB,EAAE;;AACzB;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;EACf,eAAe;AACjB;;AACA,qDAAe,kBAAkB,EAAE;;AAEnC,kBAAkB;;AAClB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA,gBAAgB;;AAChB;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA,kCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,iCAAc,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAClE,gCAAa,SAAS,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAEnF,iBAAiB;;AACjB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AACA,mCAAgB,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AACpE,kCAAe,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AACnF;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,gBAAgB;AAClB;;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,YAAY;AACd;;AACA,oCAAiB,iBAAiB,EAAE;;AAEpC,SAAS;;AACT,2BAAQ,mBAAmB,EAAE,gBAAgB,EAAE;;AAC/C;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;;AAClB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AACA,2DAAqB,wBAAwB,EAAE,0BAA0B,EAAE,WAAW,EAAE;;AACxF,6DAAuB,sBAAsB,EAAE,wBAAwB,EAAE,WAAW,EAAE;;AACtF,iCAAc,iBAAiB,EAAE;;AACjC,8BAAW,WAAW,EAAE,WAAW,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,mCAA2B,EAA3B,2BAA2B,EAAE;;AAC/G,kCAAe,wBAAwB,EAAE;;AAEzC,SAAS;;AACT;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,oDAA4C;UAA5C,4CAA4C;EAC5C,aAAa;AACf;;AACA,gCAAa,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AACjE,8BAAW,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEvF,0BAA0B;;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,yFAAiE;EAAjE,iFAAiE;EAAjE,iEAAiE;EAAjE,oHAAiE;EACjE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AACA,iCAAc,wBAAwB,EAAE,sDAA8C,EAA9C,8CAA8C,EAAE;;AACxF,kCAAe,kCAA0B,EAA1B,8BAA0B,EAA1B,0BAA0B,EAAE;;AAC3C,qCAAqC;;AACrC,6BAAU,wBAAwB,EAAE,sDAA8C,EAA9C,8CAA8C,EAAE,mBAAmB,EAAE;;AACzG,0DAAoB,sBAAsB,EAAE,WAAW,EAAE;;AACzD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA,mCAAgB,WAAW,EAAE,YAAY,EAAE;;AAC3C,8BAAW,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,oBAAiB,EAAjB,iBAAiB,EAAE,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE;;AAC9F,+BAAY,YAAY,EAAE;;AAC1B,+BAAY,gBAAgB,EAAE,eAAe,EAAE;;AAC/C,+BAAY,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE;;AAErE,eAAe;;AACf;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAe;MAAf,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AACA,+BAAY,YAAY,EAAE;;AAC1B,+BAAY,iBAAiB,EAAE,gBAAgB,EAAE;;AAEjD,mBAAmB;;AACnB,wBAAK,gBAAgB,EAAE;;AACvB,6BAAU,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;;AAChE,2BAAQ,iBAAiB,EAAE,gBAAgB,EAAE;;AAC7C,4BAAS,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEpF,UAAU;;AACV,4BAAS,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,mBAAe,EAAf,eAAe,EAAE,QAAQ,EAAE;;AACnD;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qEAA6D;EAA7D,6DAA6D;AAC/D;;AACA,iCAAc,wBAAwB,EAAE;;AACxC,6BAAU,sBAAsB,EAAE,wBAAwB,EAAE,WAAW,EAAE;;AACzE;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AACA,oCAAiB,wBAAwB,EAAE,iBAAiB,EAAE;;AAE9D,WAAW;;AACX;;;EAGE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,8BAAsB;UAAtB,sBAAsB;EACtB,aAAa;EACb,gEAAgD;EAAhD,wDAAgD;EAAhD,gDAAgD;EAAhD,0EAAgD;AAClD;;AACA;;;EAGE,wBAAwB;EACxB,oDAA4C;UAA5C,4CAA4C;AAC9C;;AACA,+BAAY,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AACnE,0BAAO,gBAAgB,EAAE;;AACzB,6BAAU,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;;AACpE,iCAAc,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAElE,uEAAuE;;AACvE,gCAAa,kBAAkB,EAAE;;AACjC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,sDAA8C;UAA9C,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;AAClB;;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;AACzC;;AACA,uCAAoB,mBAAmB,EAAE,mBAAmB,EAAE;;AAE9D,iBAAiB;;AACjB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wDAAgD;EAAhD,gDAAgD;AAClD;;AACA,mCAAgB,wBAAwB,EAAE,mBAAmB,EAAE;;AAC/D,iCAAc,iBAAiB,EAAE,kBAAkB,EAAE;;AACrD,qCAAkB,WAAW,EAAE,YAAY,EAAE;;AAC7C,iCAAc,eAAe,EAAE;;AAC/B,+BAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,mBAAe,EAAf,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AACzE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AACA,gCAAa,WAAW,EAAE,YAAY,EAAE,oBAAiB,EAAjB,iBAAiB,EAAE;;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;;AACX,kCAAe,6BAA6B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAC5G,iCAAc,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,kBAAkB,EAAE;;AACtG,oCAAiB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAC/D,gCAAa,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;;AACxE,gCAAa,mBAAmB,EAAE,gBAAgB,EAAE;;AACpD,gCAAa,iBAAiB,EAAE,gBAAgB,EAAE;;AAElD,eAAe;;AACf;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AACA,qCAAkB,wBAAwB,EAAE;;AAC5C;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;;AACA,uCAAoB,wBAAwB,EAAE,0BAA0B,EAAE;;AAC1E,mCAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD,aAAa;;AACb;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AACA,+BAAY,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAErF,YAAY;;AACZ,8BAAW,kBAAkB,EAAE,mBAAmB,EAAE;;AACpD;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA,sCAAmB,WAAW,EAAE,YAAY,EAAE;;AAC9C,mCAAgB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AACpE,kCAAe,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;;AAE/G,yDAAyD;;AACzD,gCAAa,kBAAkB,EAAE;;AACjC,gCAAa,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AACjE,+BAAY,mBAAmB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAC3G;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AACA,oCAAiB,gBAAgB,EAAE,eAAe,EAAE;;AACpD;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AACA,sCAAmB,mBAAmB,EAAE;;AACxC;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,oCAA4B;EAA5B,4BAA4B;AAC9B;;AACA,qCAAkB,wBAAwB,EAAE;;AAC5C;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AACA,mCAAgB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAC3F,mCAAgB,gBAAgB,EAAE,gBAAgB,EAAE,UAAU,EAAE;;AAChE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AAEA,uBAAuB;;AACvB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AACA,+BAAY,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AACpE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AACA,mCAAgB,0BAA0B,EAAE,mBAAmB,EAAE;;AACjE,+BAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,QAAQ,EAAE;;AAC9F,gCAAa,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;;AACrE;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wDAAgD;EAAhD,gDAAgD;AAClD;;AACA,qCAAkB,wBAAwB,EAAE,mBAAmB,EAAE;;AACjE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AACA,sCAAmB,WAAW,EAAE,YAAY,EAAE,oBAAiB,EAAjB,iBAAiB,EAAE;;AACjE,8BAAW,aAAa,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAChE;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA,wCAAqB,WAAW,EAAE,YAAY,EAAE;;AAEhD,iBAAiB;;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AACA,mCAAgB,YAAY,EAAE;;AAE9B;EACE,gCAAa,0BAA0B,EAAE;EACzC,8BAAW,8BAA8B,EAAE;AAC7C;;AACA;EACE,6BAAU,0BAA0B,EAAE;EACtC,8BAAW,0BAA0B,EAAE;EACvC,+CAA4B,aAAa,EAAE;AAC7C;;AAEA,iEAAiE;;AACjE;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kEAA0D;EAA1D,0DAA0D;AAC5D;;AACA;EACE,mCAAmC;AACrC;;AACA,mCAAgB,eAAe,EAAE;;AAEjC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,qDAA6C;UAA7C,6CAA6C;EAC7C,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;EACpC,qBAAqB;AACvB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AACA,kCAAe,kBAAkB,EAAE;;AAEnC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;;AACA,oCAAiB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAC5D,kCAAe,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAEzE,kCAAe,mBAAc,EAAd,kBAAc,EAAd,cAAc,EAAE,YAAY,EAAE;;AAC7C;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AACA,wCAAqB,0BAA0B,EAAE;;AAEjD;EACE,gBAAgB;EAChB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAe,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,kBAAkB,EAAE;EAC3D,gCAAa,YAAY,EAAE,aAAa,EAAE;AAC5C;;AAEA,6EAA6E;;AAC7E;EACE,yBAAyB;EACzB,uFAAqD;EAArD,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,oDAA4C;UAA5C,4CAA4C;AAC9C;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AACA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;EACV,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AACA,8BAAW,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AACjE,4BAAS,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,iBAAiB,EAAE;;AACrF;EACE,WAAW;EACX,8BAAsB;UAAtB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA,uCAAoB,aAAa,EAAE,wBAAwB,EAAE,qDAA6C,EAA7C,6CAA6C,EAAE;;AAC5G;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AACA,iCAAc,mBAAU,EAAV,cAAU,EAAV,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAC3F;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,gBAAgB;AAClB;;AACA,4BAAS,2BAAoB,EAApB,2BAAoB,EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ,EAAE;;AAC9D,6BAAU,iBAAiB,EAAE,mBAAmB,EAAE;;AAClD;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,iEAAsC;UAAtC,yDAAsC;AACxC;;AACA,+CAAoB,KAAK,iCAAyB,EAAzB,yBAAyB,EAAE,EAAE;;AAAtD,uCAAoB,KAAK,iCAAyB,EAAzB,yBAAyB,EAAE,EAAE","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --green: #16a34a;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* HERO */\n.hero {\n  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),\n    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;\n  padding: 48px 0 28px;\n  text-align: center;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 12px;\n}\n.h1 {\n  font-size: clamp(28px, 4.6vw, 44px);\n  line-height: 1.07;\n  font-weight: 800;\n  margin: 0 auto 12px;\n  max-width: 680px;\n}\n.hl { color: var(--red); }\n.sub {\n  font-size: clamp(15px, 2.2vw, 18px);\n  color: var(--muted);\n  max-width: 580px;\n  margin: 0 auto;\n  line-height: 1.55;\n}\n\n.eyebrowSm {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 10px;\n}\n.ctaRow {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n.ctaRow .btn { padding: 13px 26px; }\n\n/* TRUST SIGNALS */\n.trustRow {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 10px 22px;\n  margin-top: 24px;\n}\n.trustItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ink);\n}\n.trustItem svg {\n  width: 18px;\n  height: 18px;\n  color: var(--green);\n  flex: 0 0 auto;\n}\n\n/* VALUE PROPS */\n.valueWrap {\n  padding: 12px 0 56px;\n  background: #fff;\n}\n.valueGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.valueCard {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 24px;\n  background: #fff;\n  box-shadow: 0 10px 30px rgba(15, 18, 20, 0.04);\n}\n.valueIc {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.valueIc svg { width: 28px; height: 28px; }\n.valueTitle { margin: 0 0 8px; font-size: 18px; font-weight: 800; }\n.valueBody { margin: 0; font-size: 14.5px; color: var(--muted); line-height: 1.55; }\n\n/* HOW IT WORKS */\n.howWrap {\n  padding: 8px 0 72px;\n  background: #fff;\n}\n.howTitle {\n  font-size: clamp(22px, 3vw, 30px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 28px;\n}\n.howGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n.howCard {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 26px 24px;\n  background: var(--bg);\n}\n.howNo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 800;\n  font-size: 16px;\n  margin-bottom: 14px;\n}\n.howCardTitle { margin: 0 0 8px; font-size: 17px; font-weight: 800; }\n.howCardBody { margin: 0; font-size: 14px; color: var(--muted); line-height: 1.55; }\n.howCta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 32px;\n}\n.btnText {\n  appearance: none;\n  background: transparent;\n  border: none;\n  color: var(--muted);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 8px;\n}\n.btnText:hover { color: var(--red); }\n\n/* BODY */\n.body { padding: 8px 0 80px; background: #fff; }\n.loading,\n.centerState {\n  padding: 72px 0;\n  text-align: center;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n/* STEP PROGRESS */\n.steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0 0 26px;\n  flex-wrap: wrap;\n}\n.stepNode {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  color: var(--muted);\n  font-weight: 700;\n  font-size: 13.5px;\n  white-space: nowrap;\n}\n.stepDot {\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--line);\n  font-size: 12px;\n  font-weight: 800;\n  background: #fff;\n  color: var(--muted);\n}\n.stepDone .stepDot { background: var(--green); border-color: var(--green); color: #fff; }\n.stepActive .stepDot { background: var(--red); border-color: var(--red); color: #fff; }\n.stepActive { color: var(--ink); }\n.stepBar { width: 26px; height: 2px; background: var(--line); border-radius: 2px; transition: background 0.2s; }\n.stepBarDone { background: var(--green); }\n\n/* CARD */\n.card {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 18, 20, 0.04);\n  padding: 26px;\n}\n.cardTitle { font-size: 22px; font-weight: 800; margin: 0 0 4px; }\n.cardSub { color: var(--muted); font-size: 14.5px; margin: 0 0 20px; line-height: 1.5; }\n\n/* SECTION/CATEGORY GRID */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 12px;\n}\n.tile {\n  text-align: left;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: #fff;\n  padding: 16px 16px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n.tile:hover { border-color: var(--red); box-shadow: 0 6px 18px rgba(232, 35, 43, 0.08); }\n.tile:active { transform: translateY(1px); }\n/* LP-NATIVE selected category tile */\n.tileOn { border-color: var(--red); box-shadow: 0 6px 18px rgba(232, 35, 43, 0.12); background: #fff7f6; }\n.tileOn .tileIcon { background: var(--red); color: #fff; }\n.tileIcon {\n  width: 42px;\n  height: 42px;\n  border-radius: 11px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n.tileIcon svg { width: 22px; height: 22px; }\n.tileImg { width: 42px; height: 42px; border-radius: 11px; object-fit: cover; flex: 0 0 auto; }\n.tileBody { min-width: 0; }\n.tileName { font-weight: 700; font-size: 15px; }\n.tileMeta { color: var(--muted); font-size: 12.5px; margin-top: 2px; }\n\n/* BREADCRUMB */\n.crumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: var(--muted);\n  margin: 0 0 18px;\n}\n.crumbBtn {\n  border: none;\n  background: none;\n  color: var(--red);\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  font-size: 13px;\n}\n.crumbSep { opacity: 0.5; }\n.crumbCur { color: var(--ink); font-weight: 700; }\n\n/* QUESTION BLOCK */\n.q { margin: 0 0 24px; }\n.qLabel { font-weight: 700; font-size: 15.5px; margin: 0 0 4px; }\n.qReq { color: var(--red); margin-left: 4px; }\n.qHelp { color: var(--muted); font-size: 13px; margin: 0 0 12px; line-height: 1.45; }\n\n/* CHIPS */\n.chips { display: flex; flex-wrap: wrap; gap: 8px; }\n.chip {\n  border: 1px solid var(--line);\n  background: #fff;\n  border-radius: 999px;\n  padding: 9px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s, color 0.12s;\n}\n.chip:hover { border-color: var(--red); }\n.chipOn { background: var(--red); border-color: var(--red); color: #fff; }\n.moreBtn {\n  border: 1px dashed var(--line);\n  background: #fff;\n  border-radius: 999px;\n  padding: 9px 16px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--muted);\n  cursor: pointer;\n}\n.moreBtn:hover { border-color: var(--red); color: var(--red); }\n\n/* INPUTS */\n.input,\n.textarea,\n.select {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 15px;\n  font-family: inherit;\n  color: var(--ink);\n  background: #fff;\n  box-sizing: border-box;\n  outline: none;\n  transition: border-color 0.12s, box-shadow 0.12s;\n}\n.input:focus,\n.textarea:focus,\n.select:focus {\n  border-color: var(--red);\n  box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.1);\n}\n.textarea { min-height: 120px; resize: vertical; line-height: 1.5; }\n.zip { max-width: 200px; }\n.twoCol { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }\n.fieldLabel { font-weight: 700; font-size: 14px; margin: 0 0 6px; }\n\n/* Google Places address autocomplete dropdown (street-address field) */\n.addrField { position: relative; }\n.addrDropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  z-index: 30;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  box-shadow: 0 14px 40px rgba(15, 18, 20, 0.12);\n  max-height: 260px;\n  overflow-y: auto;\n}\n.addrOption {\n  padding: 10px 12px;\n  font-size: 14px;\n  color: var(--ink);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.1s, color 0.1s;\n}\n.addrOption:hover { background: #fff1f0; color: var(--red-d); }\n\n/* PHOTO UPLOAD */\n.upload {\n  border: 1.5px dashed var(--line);\n  border-radius: 14px;\n  padding: 22px;\n  text-align: center;\n  cursor: pointer;\n  color: var(--muted);\n  transition: border-color 0.12s, background 0.12s;\n}\n.upload:hover { border-color: var(--red); background: #fffafa; }\n.uploadIcon { color: var(--red); margin-bottom: 8px; }\n.uploadIcon svg { width: 26px; height: 26px; }\n.uploadHint { font-size: 13px; }\n.thumbRow { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 12px; }\n.thumb {\n  position: relative;\n  width: 84px;\n  height: 84px;\n  border-radius: 11px;\n  overflow: hidden;\n  border: 1px solid var(--line);\n}\n.thumb img { width: 100%; height: 100%; object-fit: cover; }\n.thumbX {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: none;\n  background: rgba(15, 18, 20, 0.7);\n  color: #fff;\n  font-size: 13px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n/* REVIEW */\n.reviewBlock { border: 1px solid var(--line); border-radius: 14px; padding: 16px 18px; margin-bottom: 12px; }\n.reviewHead { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }\n.reviewHead h4 { margin: 0; font-size: 15px; font-weight: 800; }\n.reviewRow { display: flex; gap: 10px; font-size: 14px; padding: 4px 0; }\n.reviewKey { color: var(--muted); min-width: 160px; }\n.reviewVal { color: var(--ink); font-weight: 600; }\n\n/* FOOTER NAV */\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--line);\n}\n.btn {\n  border-radius: 12px;\n  padding: 12px 22px;\n  font-size: 15px;\n  font-weight: 800;\n  cursor: pointer;\n  border: 1px solid var(--line);\n  background: #fff;\n  color: var(--ink);\n}\n.btnGhost:hover { border-color: var(--ink); }\n.btnPrimary {\n  background: var(--red);\n  border-color: var(--red);\n  color: #fff;\n}\n.btnPrimary:hover { background: var(--red-d); border-color: var(--red-d); }\n.btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* MESSAGES */\n.errorBox {\n  background: #fff0ef;\n  border: 1px solid #f5c6c4;\n  color: var(--red-d);\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 18px;\n}\n.fieldErr { color: var(--red); font-size: 12.5px; font-weight: 600; margin-top: 6px; }\n\n/* SUCCESS */\n.success { text-align: center; padding: 18px 0 6px; }\n.successIcon {\n  width: 68px;\n  height: 68px;\n  border-radius: 999px;\n  background: #eafaf0;\n  color: var(--green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 18px;\n}\n.successIcon svg { width: 34px; height: 34px; }\n.successTitle { font-size: 24px; font-weight: 800; margin: 0 0 8px; }\n.successText { color: var(--muted); font-size: 15px; max-width: 460px; margin: 0 auto 22px; line-height: 1.55; }\n\n/* INLINE AUTH (shown at submit for logged-out clients) */\n.authPanel { padding: 4px 0 2px; }\n.authTitle { font-size: 22px; font-weight: 800; margin: 0 0 8px; }\n.authHint { color: var(--muted); font-size: 14.5px; line-height: 1.55; margin: 0 0 18px; max-width: 540px; }\n.noticeBox {\n  background: #eafaf0;\n  border: 1px solid #bfe6cd;\n  color: #1b7a45;\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 18px;\n}\n\n/* COMPLETENESS BAR */\n.completeBox {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 16px 18px;\n  margin: 0 0 22px;\n  background: var(--bg);\n}\n.completeTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.completeLabel { font-weight: 800; font-size: 14px; }\n.completeScore {\n  font-weight: 800;\n  font-size: 14px;\n  color: var(--red);\n}\n.completeScoreOk { color: var(--green); }\n.completeTrack {\n  position: relative;\n  height: 10px;\n  border-radius: 999px;\n  background: #eceef0;\n  overflow: visible;\n}\n.completeFill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  border-radius: 999px;\n  background: var(--red);\n  transition: width 0.25s ease;\n}\n.completeFillOk { background: var(--green); }\n.completeGate {\n  position: absolute;\n  top: -3px;\n  width: 2px;\n  height: 16px;\n  background: #0f1214;\n  opacity: 0.45;\n}\n.completeHint { font-size: 13px; color: var(--muted); margin: 10px 0 0; line-height: 1.45; }\n.completeList { list-style: none; margin: 10px 0 0; padding: 0; }\n.completeItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--ink);\n  font-weight: 600;\n  padding: 3px 0;\n}\n.completeDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--red);\n  flex: 0 0 auto;\n}\n\n/* GUIDED PHOTO SLOTS */\n.photoSummary {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin: 0 0 16px;\n}\n.photoCount {\n  font-weight: 800;\n  font-size: 14px;\n  color: var(--ink);\n  background: #fff0ef;\n  border-radius: 999px;\n  padding: 6px 14px;\n}\n.photoReq { font-weight: 700; font-size: 13px; color: var(--muted); }\n.slotGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n}\n.slotTile {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 14px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.slotTileDone { border-color: var(--green); background: #f6fdf9; }\n.slotHead { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }\n.slotLabel { font-weight: 700; font-size: 13.5px; line-height: 1.35; }\n.slotReq {\n  flex: 0 0 auto;\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--red);\n  background: #fff0ef;\n  border-radius: 999px;\n  padding: 3px 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.slotOpt {\n  flex: 0 0 auto;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--muted);\n  background: var(--bg);\n  border-radius: 999px;\n  padding: 3px 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.slotDrop {\n  border: 1.5px dashed var(--line);\n  border-radius: 12px;\n  padding: 18px;\n  text-align: center;\n  cursor: pointer;\n  color: var(--muted);\n  transition: border-color 0.12s, background 0.12s;\n}\n.slotDrop:hover { border-color: var(--red); background: #fffafa; }\n.slotPreview {\n  position: relative;\n  width: 100%;\n  height: 130px;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid var(--line);\n}\n.slotPreview img { width: 100%; height: 100%; object-fit: cover; }\n.slotPdf { padding: 14px; font-size: 12px; color: var(--muted); }\n.slotDoneBadge {\n  position: absolute;\n  bottom: 6px;\n  left: 6px;\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  background: var(--green);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.slotDoneBadge svg { width: 14px; height: 14px; }\n\n/* MEASUREMENTS */\n.measureGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 18px;\n}\n.measureField { min-width: 0; }\n\n@media (max-width: 900px) {\n  .valueGrid { grid-template-columns: 1fr; }\n  .howGrid { grid-template-columns: 1fr 1fr; }\n}\n@media (max-width: 640px) {\n  .twoCol { grid-template-columns: 1fr; }\n  .howGrid { grid-template-columns: 1fr; }\n  .stepNode span:last-child { display: none; }\n}\n\n/* ---- Photo handoff (scan-to-add-photos-from-your-phone) ---- */\n.handoffPanel {\n  margin-top: 20px;\n}\n\n.handoffOpenBtn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: 1.5px dashed var(--red);\n  background: rgba(232, 35, 43, 0.04);\n  color: var(--red-d);\n  border-radius: 14px;\n  padding: 16px 18px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n.handoffOpenBtn:hover {\n  background: rgba(232, 35, 43, 0.08);\n}\n.handoffPhone { font-size: 18px; }\n\n.handoffOpen {\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 8px 28px rgba(15, 18, 20, 0.06);\n  overflow: hidden;\n}\n.handoffHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--line);\n  background: var(--bg);\n}\n.handoffTitle {\n  font-size: 15px;\n  font-weight: 800;\n  letter-spacing: -0.2px;\n}\n.handoffClose {\n  border: none;\n  background: transparent;\n  font-size: 24px;\n  line-height: 1;\n  color: var(--muted);\n  cursor: pointer;\n  padding: 0 4px;\n}\n.handoffBody { padding: 20px 18px; }\n\n.handoffGrid {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n.handoffQr {\n  flex: 0 0 auto;\n  width: 160px;\n  height: 160px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 8px;\n}\n.handoffQr svg { width: 100%; height: 100%; display: block; }\n.handoffNoQr { font-size: 13px; color: var(--muted); text-align: center; }\n\n.handoffText { flex: 1 1 auto; min-width: 0; }\n.handoffLead {\n  margin: 0 0 8px;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n.handoffSmall {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: var(--muted);\n  line-height: 1.5;\n}\n.handoffLink {\n  display: inline-block;\n  font-size: 12px;\n  color: var(--red-d);\n  word-break: break-all;\n  text-decoration: none;\n}\n.handoffLink:hover { text-decoration: underline; }\n\n.handoffCount {\n  margin-top: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--green);\n}\n.handoffCheck {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--green);\n  color: #fff;\n  font-size: 12px;\n}\n.handoffRetry {\n  border: 1px solid var(--line);\n  background: #fff;\n  border-radius: 10px;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n@media (max-width: 640px) {\n  .handoffGrid { flex-direction: column; text-align: center; }\n  .handoffQr { width: 200px; height: 200px; }\n}\n\n/* AI \"describe your project in your own words\" assistant (start of wizard) */\n.aiBox {\n  border: 1px solid #f6d4d3;\n  background: linear-gradient(180deg, #fff7f6, #ffffff);\n  border-radius: 16px;\n  padding: 18px;\n  margin: 0 0 22px;\n  box-shadow: 0 1px 2px rgba(15, 18, 20, 0.03);\n}\n.aiHead {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.aiBadge {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  background: var(--red);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n.aiTitle { font-size: 16px; font-weight: 800; color: var(--ink); }\n.aiSub { font-size: 13.5px; color: var(--muted); margin-top: 2px; line-height: 1.45; }\n.aiTextarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 14.5px;\n  line-height: 1.5;\n  font-family: inherit;\n  color: var(--ink);\n  background: #fff;\n  resize: vertical;\n  min-height: 96px;\n}\n.aiTextarea:focus { outline: none; border-color: var(--red); box-shadow: 0 0 0 3px rgba(232, 35, 43, 0.12); }\n.aiDone {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #166534;\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n.aiDone svg { flex: none; width: 18px; height: 18px; color: var(--green); margin-top: 1px; }\n.aiFollow {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #fff7f6;\n  border: 1px solid #f6d4d3;\n  color: var(--ink);\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n.aiErr {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #fafbfc;\n  border: 1px solid var(--line);\n  color: var(--muted);\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n.aiActions {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n}\n.aiBtn { display: inline-flex; align-items: center; gap: 8px; }\n.aiHint { font-size: 12.5px; color: var(--muted); }\n.aiSpinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: aiSpin 0.7s linear infinite;\n}\n@keyframes aiSpin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `PostAProject-page-fjQEo`,
	"wrap": `PostAProject-wrap-blo7j`,
	"hero": `PostAProject-hero-Nm5Yo`,
	"eyebrow": `PostAProject-eyebrow-qb5c8`,
	"h1": `PostAProject-h1-tu209`,
	"hl": `PostAProject-hl-UKLJU`,
	"sub": `PostAProject-sub-rgHO8`,
	"eyebrowSm": `PostAProject-eyebrowSm-AoMaS`,
	"ctaRow": `PostAProject-ctaRow-D1rN8`,
	"btn": `PostAProject-btn-elFoH`,
	"trustRow": `PostAProject-trustRow-wJPBd`,
	"trustItem": `PostAProject-trustItem-OHHuy`,
	"valueWrap": `PostAProject-valueWrap-OzbpT`,
	"valueGrid": `PostAProject-valueGrid-v1BNx`,
	"valueCard": `PostAProject-valueCard-QckER`,
	"valueIc": `PostAProject-valueIc-taZHb`,
	"valueTitle": `PostAProject-valueTitle-sUyls`,
	"valueBody": `PostAProject-valueBody-kmPF0`,
	"howWrap": `PostAProject-howWrap-DbE5F`,
	"howTitle": `PostAProject-howTitle-lNMSz`,
	"howGrid": `PostAProject-howGrid-OvQ1V`,
	"howCard": `PostAProject-howCard-g8DuO`,
	"howNo": `PostAProject-howNo-AFb_s`,
	"howCardTitle": `PostAProject-howCardTitle-iwvEK`,
	"howCardBody": `PostAProject-howCardBody-P3KHq`,
	"howCta": `PostAProject-howCta-R6baj`,
	"btnText": `PostAProject-btnText-g4OAb`,
	"body": `PostAProject-body-EjlZ_`,
	"loading": `PostAProject-loading-R3FG0`,
	"centerState": `PostAProject-centerState-IQCb2`,
	"steps": `PostAProject-steps-M0psp`,
	"stepNode": `PostAProject-stepNode-um_Yx`,
	"stepDot": `PostAProject-stepDot-XpuCq`,
	"stepDone": `PostAProject-stepDone-fHDz_`,
	"stepActive": `PostAProject-stepActive-r9cqs`,
	"stepBar": `PostAProject-stepBar-ERqhF`,
	"stepBarDone": `PostAProject-stepBarDone-WF6er`,
	"card": `PostAProject-card-axpSj`,
	"cardTitle": `PostAProject-cardTitle-HAkU2`,
	"cardSub": `PostAProject-cardSub-vJYrD`,
	"grid": `PostAProject-grid-gIlXC`,
	"tile": `PostAProject-tile-Nvcd7`,
	"tileOn": `PostAProject-tileOn-B9u0B`,
	"tileIcon": `PostAProject-tileIcon-U4zlx`,
	"tileImg": `PostAProject-tileImg-jltAm`,
	"tileBody": `PostAProject-tileBody-nE5T5`,
	"tileName": `PostAProject-tileName-H2AqL`,
	"tileMeta": `PostAProject-tileMeta-WWHwa`,
	"crumb": `PostAProject-crumb-Mmzdh`,
	"crumbBtn": `PostAProject-crumbBtn-LeSv6`,
	"crumbSep": `PostAProject-crumbSep-omyIs`,
	"crumbCur": `PostAProject-crumbCur-wy5cJ`,
	"q": `PostAProject-q-pKAyR`,
	"qLabel": `PostAProject-qLabel-oe0rg`,
	"qReq": `PostAProject-qReq-qraBK`,
	"qHelp": `PostAProject-qHelp-lAOxJ`,
	"chips": `PostAProject-chips-bWULB`,
	"chip": `PostAProject-chip-XfkoF`,
	"chipOn": `PostAProject-chipOn-ovbij`,
	"moreBtn": `PostAProject-moreBtn-dukTo`,
	"input": `PostAProject-input-THEDe`,
	"textarea": `PostAProject-textarea-eLBIC`,
	"select": `PostAProject-select-I3wOG`,
	"zip": `PostAProject-zip-AWTvv`,
	"twoCol": `PostAProject-twoCol-EHzhI`,
	"fieldLabel": `PostAProject-fieldLabel-yHK7D`,
	"addrField": `PostAProject-addrField-hd2Ej`,
	"addrDropdown": `PostAProject-addrDropdown-o42TZ`,
	"addrOption": `PostAProject-addrOption-Yfn3W`,
	"upload": `PostAProject-upload-xuvRw`,
	"uploadIcon": `PostAProject-uploadIcon-V9giM`,
	"uploadHint": `PostAProject-uploadHint-Efszq`,
	"thumbRow": `PostAProject-thumbRow-gEDdc`,
	"thumb": `PostAProject-thumb-TJjrx`,
	"thumbX": `PostAProject-thumbX-adp0P`,
	"reviewBlock": `PostAProject-reviewBlock-ZuDBx`,
	"reviewHead": `PostAProject-reviewHead-Kt6Cz`,
	"reviewRow": `PostAProject-reviewRow-w_wOo`,
	"reviewKey": `PostAProject-reviewKey-hNnVZ`,
	"reviewVal": `PostAProject-reviewVal-Y0B4t`,
	"footer": `PostAProject-footer-IyHBN`,
	"btnGhost": `PostAProject-btnGhost-_AP8Z`,
	"btnPrimary": `PostAProject-btnPrimary-cJGAY`,
	"errorBox": `PostAProject-errorBox-oMo0r`,
	"fieldErr": `PostAProject-fieldErr-JXsxI`,
	"success": `PostAProject-success-ob87T`,
	"successIcon": `PostAProject-successIcon-A3ZD_`,
	"successTitle": `PostAProject-successTitle-a0Iby`,
	"successText": `PostAProject-successText-ISeUv`,
	"authPanel": `PostAProject-authPanel-rAqXS`,
	"authTitle": `PostAProject-authTitle-afeiy`,
	"authHint": `PostAProject-authHint-Fu2vu`,
	"noticeBox": `PostAProject-noticeBox-Bme94`,
	"completeBox": `PostAProject-completeBox-Dz_1b`,
	"completeTop": `PostAProject-completeTop-m8aMZ`,
	"completeLabel": `PostAProject-completeLabel-s8gWT`,
	"completeScore": `PostAProject-completeScore-gc5Na`,
	"completeScoreOk": `PostAProject-completeScoreOk-da1lR`,
	"completeTrack": `PostAProject-completeTrack-EFSKJ`,
	"completeFill": `PostAProject-completeFill-Ws0By`,
	"completeFillOk": `PostAProject-completeFillOk-GjrYV`,
	"completeGate": `PostAProject-completeGate-bWKUB`,
	"completeHint": `PostAProject-completeHint-v_oKu`,
	"completeList": `PostAProject-completeList-BFWr6`,
	"completeItem": `PostAProject-completeItem-t2c5B`,
	"completeDot": `PostAProject-completeDot-iWRGm`,
	"photoSummary": `PostAProject-photoSummary-RA1k7`,
	"photoCount": `PostAProject-photoCount-HyqXZ`,
	"photoReq": `PostAProject-photoReq-aMxTA`,
	"slotGrid": `PostAProject-slotGrid-WCMoo`,
	"slotTile": `PostAProject-slotTile-lHUol`,
	"slotTileDone": `PostAProject-slotTileDone-XLcCX`,
	"slotHead": `PostAProject-slotHead-X3Vls`,
	"slotLabel": `PostAProject-slotLabel-Hly9i`,
	"slotReq": `PostAProject-slotReq-C2n7K`,
	"slotOpt": `PostAProject-slotOpt-YxFDX`,
	"slotDrop": `PostAProject-slotDrop-cScz4`,
	"slotPreview": `PostAProject-slotPreview-xSAjK`,
	"slotPdf": `PostAProject-slotPdf-HwNi4`,
	"slotDoneBadge": `PostAProject-slotDoneBadge-Vzlun`,
	"measureGrid": `PostAProject-measureGrid-J8lbd`,
	"measureField": `PostAProject-measureField-tALzP`,
	"handoffPanel": `PostAProject-handoffPanel-Phd1N`,
	"handoffOpenBtn": `PostAProject-handoffOpenBtn-jpYVP`,
	"handoffPhone": `PostAProject-handoffPhone-k5aZe`,
	"handoffOpen": `PostAProject-handoffOpen-UXJ8G`,
	"handoffHead": `PostAProject-handoffHead-uLE66`,
	"handoffTitle": `PostAProject-handoffTitle-MKgog`,
	"handoffClose": `PostAProject-handoffClose-FPuJw`,
	"handoffBody": `PostAProject-handoffBody-xpXyf`,
	"handoffGrid": `PostAProject-handoffGrid-UYwmo`,
	"handoffQr": `PostAProject-handoffQr-QZolq`,
	"handoffNoQr": `PostAProject-handoffNoQr-qX_n2`,
	"handoffText": `PostAProject-handoffText-w5uE5`,
	"handoffLead": `PostAProject-handoffLead-vKSlN`,
	"handoffSmall": `PostAProject-handoffSmall-zww5O`,
	"handoffLink": `PostAProject-handoffLink-_wIU8`,
	"handoffCount": `PostAProject-handoffCount-Meam4`,
	"handoffCheck": `PostAProject-handoffCheck-dmeHG`,
	"handoffRetry": `PostAProject-handoffRetry-dJgDR`,
	"aiBox": `PostAProject-aiBox-DxX0a`,
	"aiHead": `PostAProject-aiHead-i9e4G`,
	"aiBadge": `PostAProject-aiBadge-0rMHD`,
	"aiTitle": `PostAProject-aiTitle-FKrL6`,
	"aiSub": `PostAProject-aiSub-YDhoo`,
	"aiTextarea": `PostAProject-aiTextarea-z13x2`,
	"aiDone": `PostAProject-aiDone-HTmID`,
	"aiFollow": `PostAProject-aiFollow-BCUMj`,
	"aiErr": `PostAProject-aiErr-yu5xo`,
	"aiActions": `PostAProject-aiActions-nLlho`,
	"aiBtn": `PostAProject-aiBtn-Ckgd9`,
	"aiHint": `PostAProject-aiHint-PtSc8`,
	"aiSpinner": `PostAProject-aiSpinner-uCBNy`,
	"aiSpin": `PostAProject-aiSpin-EGlwU`
};
module.exports = ___CSS_LOADER_EXPORT___;
